
































import Settings from '../users/UserSettings.vue';
import Groups from '../groups/Groups.vue';
import GlobalFilter from './GlobalFilter.vue';
import MobileGroupsProfile from './MobileGroupsProfile.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { types } from '../../store/types/types.js';
import { useUserProfileStore } from '../../../shared/stores';
import GlobalSearchBar from '../global_search/GlobalSearchBar.vue';
import { useRoute, useRouter } from 'vue-router/composables';
import GlobalSearchToggle from '../global_search/GlobalSearchToggle.vue';

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const handleSearch = query => {
      router.push({ name: 'global-search', query: { ...route.query, query: query.value } }).catch(() => {});
    };

    return {
      searchedQuery: route.query.query?.toString() || '',
      handleSearch,
    };
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapGetters({
      isMobile: types.GET_IS_MOBILE,
      chosenSubscriptionId: types.MESSAGES_GET_SELECTED_SUBSCRIPTION_ID,
      showHeader: types.GET_SHOW_HEADER,
    }),
    userProfileStore() {
      return useUserProfileStore();
    },
    profile() {
      return this.userProfileStore.institutionProfile;
    },
  },
  methods: {
    ...mapActions({
      resetSubscription: types.RESET_SELECT_SUBSCRIPTION,
    }),
    ...mapMutations({
      setIsMobile: types.MUTATE_IS_MOBILE,
      setIsTablet: types.MUTATE_IS_TABLET,
    }),
    detectIsMobile() {
      this.setIsMobile();
      this.setIsTablet();
    },
  },
  created() {
    window.addEventListener('orientationchange', this.detectIsMobile);
  },
  beforeDestroy() {
    window.removeEventListener('orientationchange', this.detectIsMobile, false);
  },
  components: {
    GlobalSearchToggle,
    GlobalSearchBar,
    settings: Settings,
    groups: Groups,
    'global-filter': GlobalFilter,
    'mobile-groups-profile': MobileGroupsProfile,
  },
};
